import { render, staticRenderFns } from "./nsvSerialProductPlatform.vue?vue&type=template&id=6a74d3f8&scoped=true&"
import script from "./nsvSerialProductPlatform.vue?vue&type=script&lang=tsx&"
export * from "./nsvSerialProductPlatform.vue?vue&type=script&lang=tsx&"
import style0 from "./nsvSerialProductPlatform.vue?vue&type=style&index=0&id=6a74d3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74d3f8",
  null
  
)

export default component.exports